import { settingsApi as api } from './settingsApi';
export const addTagTypes = [
  'account_details',
  'common',
  'matching',
  'notifications',
  'Cron Controller',
  'user'
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      accountDetailsParametersList: build.query<
        AccountDetailsParametersListApiResponse,
        AccountDetailsParametersListApiArg
      >({
        query: queryArg => ({
          url: `/account_details/parameters/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['account_details']
      }),
      accountDetailsParametersPartialUpdate: build.mutation<
        AccountDetailsParametersPartialUpdateApiResponse,
        AccountDetailsParametersPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/account_details/parameters/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.parameters
        }),
        invalidatesTags: ['account_details']
      }),
      commonGeneralSettingsList: build.query<
        CommonGeneralSettingsListApiResponse,
        CommonGeneralSettingsListApiArg
      >({
        query: queryArg => ({
          url: `/common/general_settings/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            type: queryArg['type'],
            country: queryArg.country
          }
        }),
        providesTags: ['common']
      }),
      commonGeneralSettingsPartialUpdate: build.mutation<
        CommonGeneralSettingsPartialUpdateApiResponse,
        CommonGeneralSettingsPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/common/general_settings/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.generalRule
        }),
        invalidatesTags: ['common']
      }),
      matchingMatchingControllerList: build.query<
        MatchingMatchingControllerListApiResponse,
        MatchingMatchingControllerListApiArg
      >({
        query: queryArg => ({
          url: `/matching/matching_controller/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset,
            is_active: queryArg.isActive
          }
        }),
        providesTags: ['matching']
      }),
      matchingMatchingControllerMatchingControl: build.mutation<
        MatchingMatchingControllerMatchingControlApiResponse,
        MatchingMatchingControllerMatchingControlApiArg
      >({
        query: queryArg => ({
          url: `/matching/matching_controller/matching_control/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['matching']
      }),
      matchingMatchingControllerStatusOptController: build.query<
        MatchingMatchingControllerStatusOptControllerApiResponse,
        MatchingMatchingControllerStatusOptControllerApiArg
      >({
        query: queryArg => ({
          url: `/matching/matching_controller/status_opt_controller/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['matching']
      }),
      matchingOptControllerList: build.query<
        MatchingOptControllerListApiResponse,
        MatchingOptControllerListApiArg
      >({
        query: queryArg => ({
          url: `/matching/opt_controller/`,
          params: {
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['matching']
      }),
      matchingOptControllerRead: build.query<
        MatchingOptControllerReadApiResponse,
        MatchingOptControllerReadApiArg
      >({
        query: queryArg => ({
          url: `/matching/opt_controller/${queryArg.uuid}/`
        }),
        providesTags: ['matching']
      }),
      matchingOptControllerPartialUpdate: build.mutation<
        MatchingOptControllerPartialUpdateApiResponse,
        MatchingOptControllerPartialUpdateApiArg
      >({
        query: queryArg => ({
          url: `/matching/opt_controller/${queryArg.uuid}/`,
          method: 'PATCH',
          body: queryArg.optControl
        }),
        invalidatesTags: ['matching']
      }),
      matchingOptControllerDelete: build.mutation<
        MatchingOptControllerDeleteApiResponse,
        MatchingOptControllerDeleteApiArg
      >({
        query: queryArg => ({
          url: `/matching/opt_controller/${queryArg.uuid}/`,
          method: 'DELETE'
        }),
        invalidatesTags: ['matching']
      }),
      notificationsBatchDetailsList: build.query<
        NotificationsBatchDetailsListApiResponse,
        NotificationsBatchDetailsListApiArg
      >({
        query: queryArg => ({
          url: `/notifications/batch_details/`,
          params: {
            batch_id: queryArg.batchId,
            status: queryArg.status,
            date: queryArg.date,
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['notifications']
      }),
      notificationsCronList: build.query<
        NotificationsCronListApiResponse,
        NotificationsCronListApiArg
      >({
        query: queryArg => ({
          url: `/notifications/cron/`,
          params: {
            name: queryArg.name,
            last_run_timestamp: queryArg.lastRunTimestamp,
            last_run_status: queryArg.lastRunStatus,
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['notifications']
      }),
      notificationsCronControllerCron: build.mutation<
        NotificationsCronControllerCronApiResponse,
        NotificationsCronControllerCronApiArg
      >({
        query: queryArg => ({
          url: `/notifications/cron/controller-cron/`,
          method: 'POST',
          body: queryArg.cronControllerRequest
        }),
        invalidatesTags: ['Cron Controller']
      }),
      notificationsCronDetailsList: build.query<
        NotificationsCronDetailsListApiResponse,
        NotificationsCronDetailsListApiArg
      >({
        query: queryArg => ({
          url: `/notifications/cron_details/`,
          params: {
            batch: queryArg.batch,
            batch__batch_id: queryArg.batchBatchId,
            batch__status: queryArg.batchStatus,
            batch__date: queryArg.batchDate,
            name: queryArg.name,
            cron: queryArg.cron,
            start_time: queryArg.startTime,
            end_time: queryArg.endTime,
            status: queryArg.status,
            search: queryArg.search,
            ordering: queryArg.ordering,
            limit: queryArg.limit,
            offset: queryArg.offset
          }
        }),
        providesTags: ['notifications']
      }),
      userFileUploadUploadExcel: build.mutation<
        UserFileUploadUploadExcelApiResponse,
        UserFileUploadUploadExcelApiArg
      >({
        query: queryArg => ({
          url: `/user/file_upload/upload_excel/`,
          method: 'POST',
          body: queryArg.body
        }),
        invalidatesTags: ['user']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type AccountDetailsParametersListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: ParametersRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type AccountDetailsParametersListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type AccountDetailsParametersPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: ParametersRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type AccountDetailsParametersPartialUpdateApiArg = {
  uuid: string;
  parameters: Parameters;
};
export type CommonGeneralSettingsListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: GeneralRuleRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type CommonGeneralSettingsListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Type of general setting */
  type?: 'zipcode';
  /** Country UUID */
  country?: string;
};
export type CommonGeneralSettingsPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: GeneralRuleRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type CommonGeneralSettingsPartialUpdateApiArg = {
  uuid: string;
  generalRule: GeneralRule;
};
export type MatchingMatchingControllerListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: any;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingMatchingControllerListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  /** Filter regions by active status (true/false). Returns all regions when omitted. */
  isActive?: boolean;
};
export type MatchingMatchingControllerMatchingControlApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: {};
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingMatchingControllerMatchingControlApiArg = {
  body: {
    region_id?: string[];
  };
};
export type MatchingMatchingControllerStatusOptControllerApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: {
      total: number;
      pending: number;
      running: number;
    };
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingMatchingControllerStatusOptControllerApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type MatchingOptControllerListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: OptControlRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingOptControllerListApiArg = {
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type MatchingOptControllerReadApiResponse =
  /** status 200 Custom Response */ {
    results: OptControlRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingOptControllerReadApiArg = {
  uuid: string;
};
export type MatchingOptControllerPartialUpdateApiResponse =
  /** status 200 Custom Response */ {
    results: OptControlRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingOptControllerPartialUpdateApiArg = {
  uuid: string;
  optControl: OptControl;
};
export type MatchingOptControllerDeleteApiResponse =
  /** status 200 Custom Response */ {
    results: OptControlRead;
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type MatchingOptControllerDeleteApiArg = {
  uuid: string;
};
export type NotificationsBatchDetailsListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: BatchControllerRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type NotificationsBatchDetailsListApiArg = {
  /** batch_id */
  batchId?: string;
  /** status */
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
  /** date */
  date?: string;
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type NotificationsCronListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: CronDetailedRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type NotificationsCronListApiArg = {
  /** name */
  name?: string;
  /** last_run_timestamp */
  lastRunTimestamp?: string;
  /** last_run_status */
  lastRunStatus?: 'success' | 'failed' | 'running' | 'pending' | 'cancelled';
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
};
export type NotificationsCronControllerCronApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: CronDetailedRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type NotificationsCronControllerCronApiArg = {
  cronControllerRequest: CronControllerRequest;
};
export type NotificationsCronDetailsListApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: CronControllerRead[];
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type NotificationsCronDetailsListApiArg = {
  /** batch */
  batch?: string;
  /** batch__batch_id */
  batchBatchId?: string;
  /** batch__status */
  batchStatus?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
  /** batch__date */
  batchDate?: string;
  /** name */
  name?: string;
  /** start_time */
  startTime?: string;
  /** end_time */
  endTime?: string;
  /** status */
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
  /** A search term. */
  search?: string;
  /** Which field to use when ordering the results. */
  ordering?: string;
  /** Number of results to return per page. */
  limit?: number;
  /** The initial index from which to return the results. */
  offset?: number;
  cron?: string;
};
export type UserFileUploadUploadExcelApiResponse =
  /** status 200 Custom Response */ {
    count?: number;
    next?: string | null;
    previous?: string | null;
    results: {};
    ok?: boolean;
    message?: {
      text?: string | null;
      code?: number;
      args?: object | null;
    };
  };
export type UserFileUploadUploadExcelApiArg = {
  body: FormData;
};
export type Parameters = {
  date_time?: string | null;
  re_request_days?: number | null;
  reminder_days?: number | null;
  re_match_days?: number | null;
  leeway?: number | null;
  emergency_email?: string | null;
  nudge_days?: number | null;
  pause_days?: number | null;
  retire_days?: number | null;
  inactive_days?: number | null;
  archive_days?: number | null;
  match_cutoff?: string | null;
  match_cutoff_prev?: string | null;
  no_response_days?: number | null;
  one_week_notice?: number | null;
  contact_reset?: number | null;
};
export type ParametersRead = {
  uuid?: string;
  date_time?: string | null;
  re_request_days?: number | null;
  reminder_days?: number | null;
  re_match_days?: number | null;
  leeway?: number | null;
  emergency_email?: string | null;
  nudge_days?: number | null;
  pause_days?: number | null;
  retire_days?: number | null;
  inactive_days?: number | null;
  archive_days?: number | null;
  match_cutoff?: string | null;
  match_cutoff_prev?: string | null;
  no_response_days?: number | null;
  one_week_notice?: number | null;
  contact_reset?: number | null;
};
export type GeneralRule = {
  key: string;
  value: string;
};
export type GeneralRuleRead = {
  uuid?: string;
  key: string;
  value: string;
};
export type OptControl = {
  batch_id?: number | null;
  timestamp?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  region?: string | null;
  region_name?: string | null;
  status?: string | null;
  total_demand?: number | null;
  total_supply?: number | null;
  supply_matched?: number | null;
  demand_matched?: number | null;
  percent_demand_met?: string | null;
  percent_supply_used?: string | null;
  matches_made?: number | null;
  optimizer_message?: string | null;
  process_date?: string | null;
};
export type OptControlRead = {
  uuid?: string;
  run_id?: number;
  batch_id?: number | null;
  timestamp?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  region?: string | null;
  region_name?: string | null;
  status?: string | null;
  total_demand?: number | null;
  total_supply?: number | null;
  supply_matched?: number | null;
  demand_matched?: number | null;
  percent_demand_met?: string | null;
  percent_supply_used?: string | null;
  matches_made?: number | null;
  optimizer_message?: string | null;
  process_date?: string | null;
};
export type BatchController = {
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
};
export type BatchControllerRead = {
  id?: string;
  created_at?: string;
  updated_at?: string;
  batch_id?: number;
  date?: string;
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
};
export type CronDetailed = {
  uuid: string;
  params: {};
};
export type CronDetailedRead = {
  id?: string;
  created_at?: string;
  updated_at?: string;
  name: string;
  description?: string | null;
  parameters_data?: object | null;
  last_run_status?:
    | ('success' | 'failed' | 'running' | 'pending' | 'cancelled')
    | null;
  last_run_timestamp?: string | null;
  last_run_log_url?: string | null;
  endpoint?: string | null;
};
export type CronControllerRequest = {
  /** UUID of the cron job to control */
  uuid: string;
  /** Parameters for the cron controller. Example: {'retry': {'type': 'int', 'value': 1}} */
  params?: object;
};
export type CronController = {
  name: string;
  start_time?: string;
  end_time?: string | null;
  details?: string | null;
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
  batch?: string | null;
};
export type CronControllerRead = {
  id?: string;
  created_at?: string;
  updated_at?: string;
  name: string;
  start_time?: string;
  end_time?: string | null;
  details?: string | null;
  status?: 'pending' | 'ongoing' | 'completed' | 'cancelled';
  batch?: string | null;
};
export const {
  useAccountDetailsParametersListQuery,
  useAccountDetailsParametersPartialUpdateMutation,
  useCommonGeneralSettingsListQuery,
  useCommonGeneralSettingsPartialUpdateMutation,
  useMatchingMatchingControllerListQuery,
  useMatchingMatchingControllerMatchingControlMutation,
  useMatchingMatchingControllerStatusOptControllerQuery,
  useMatchingOptControllerListQuery,
  useMatchingOptControllerReadQuery,
  useMatchingOptControllerPartialUpdateMutation,
  useMatchingOptControllerDeleteMutation,
  useNotificationsBatchDetailsListQuery,
  useNotificationsCronListQuery,
  useNotificationsCronControllerCronMutation,
  useNotificationsCronDetailsListQuery,
  useUserFileUploadUploadExcelMutation
} = injectedRtkApi;
